import { defineStore } from 'pinia'

export const useSkeleton = defineStore('loading', {
    state: () => ({
        headerFlag: false,
        banners: false,
        mainCategories: false,
        homeGroups: false,
        shops: false,
        storeDetail : false,
        storeProduct : false,
        product : false
    }),
    getters: {
        homeLoaded: (state) => {
            console.log(state);
            return state.headerFlag && state.banners && state.mainCategories && state.homeGroups
        },
        shopsLoaded: (state) => {
            return state.headerFlag && state.shops
        },
        storeLoaded: (state) => {
            return state.headerFlag && state.storeDetail && state.storeProduct
        },
        productLoaded: (state) => {
            return state.headerFlag && state.product
        }
    }
})
